<template>
  <div>
    <span class="weui-switch" :class="{'weui-switch-on' : me_checked_calc=='on'}" :value="value"  @click.stop="toggle"></span>
  </div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
  export default {
    props: {
      value: {
        type: String
      },
      shareId:{
        type: String,
        default: ''
      }
    },
    data:()=>({
        me_checked: this.value,
        canIClick: true,
        user:commonUtils.getUser()
    }),
    computed:{
      me_checked_calc(){
          return this.value
      }
    },
    watch: {

    },
    methods: {
      toggle() {
        let that = this;
          //如果用户两种验证方式都没添加，则弹窗报错信息
        if((!this.$parent.emialShow && !this.$parent.txtShow)){
                   that.$toast({
                        text: that.$t('language.twoStepverification.addVerify'),
                        type: 'fail',
                        idValue: "verificationUpdate"
                        });
                    return;
        }
        // 防止频繁点击，只有在接口有返回过后才能再次发送请求    防抖与节流不太适合此场景
        if(this.me_checked_calc == "on"){
           this.Utils.doDualVerifyRequest('status',{userId:this.user.id}).then(res=>{
                if(res.status==200){
                     that.me_checked = 'off';
                     that.$emit('input', this.me_checked);
                     that.$parent.$forceUpdate();
                }else{
                     that.$toast({
                        text: that.$t('language.exception.'+res.reason),
                        type: 'fail',
                        idValue: "verificationUpdate"
                        });
                }
           });
           return;
        }
         this.Utils.doDualVerifyRequest('status',{userId:this.user.id}).then(res=>{
                if(res.status==200){
                     that.me_checked = "on";
                     that.$emit('input', this.me_checked);
                     that.$parent.$forceUpdate();
                }else{
                      that.$toast({
                        text:that.$t('language.exception.'+res.reason),
                        type: 'fail',
                        idValue: "verificationUpdate"
                        });
                }
           });
      }
    }
  }
</script>

<style>
  .weui-switch {
    margin: 0 auto;
    display: block;
    position: relative;
    width: 21px;
    height: 11px;
    border: 1px solid #DFDFDF;
    outline: 0;
    border-radius: 11px;
    box-sizing: border-box;
    background-color: #DFDFDF;
    transition: background-color 0.1s, border 0.1s;
    cursor: pointer;
  }
  .weui-switch:before {
    content: " ";
    position: absolute;
    top: 0;
    left: 0;
    width: 20px;
    height: 10px;
    border-radius: 10px;
    background-color: #FDFDFD;
    transition: transform 0.35s cubic-bezier(0.45, 1, 0.4, 1);
  }
  .weui-switch:after {
    content: " ";
    position: absolute;
    top: 0;
    left: 0;
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background-color: #FFFFFF;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
    transition: transform 0.35s cubic-bezier(0.4, 0.4, 0.25, 1.35);
  }
  .weui-switch-on {
    border-color: #5166BD;
    background-color: #5166BD;
  }
  .weui-switch-on:before {
    border-color: #5166BD;
    background-color: #5166BD;
  }
  .weui-switch-on:after {
    transform: translateX(10px);
  }
</style>



// WEBPACK FOOTER //
// src/components/common/input/verification_switch.vue